class ModuleManager {

    _listeners = [];

    add_listeners() {
        const { singles, collections } = this.define_listeners();
        const listener_array = [];
        console.log('Adding listeners for:', this.constructor.name)
        // Singles
        singles.forEach(values => {
            const [element, event, handler, once] = values;
            if (element) {
                listener_array.push({ element, event, handler: handler.bind(this), once });
            }
        });

        // Collections
        collections.forEach(values => {
            const [collection, event, handler, once] = values;
            collection.forEach(element => {
                listener_array.push({ element, event, handler: handler.bind(this), once });
            });
        });
        
        // Attach to DOM
        listener_array.forEach(listener => {
            const options = listener.once ? { once: true } : {};
            listener.element.addEventListener(listener.event, listener.handler, options);
            this._listeners.push(listener);
        });
    }

    remove_listeners() {
        this._listeners.forEach(listener => {
            listener.element.removeEventListener(listener.event, listener.handler);
        });
        this._listeners = [];
    }

    destroy() {
        this.remove_listeners();
    }

    define_listeners() {
        throw new Error('You must implement the define_listeners() method in the child class.');
    }

};
